module.exports = __webpack_public_path__ + "static/AW_student-318e1b4dc0494a4ff790b08ee05e21db.jpg";